<template>
    <div class="root" v-if="show">
        <div class="container" id="target-container"
        :style="{
              padding: 0 +'px',
              border: '1px solid blue',
              height: 500 + 'px',
              width: 600 + 'px',
              top: 100 + 'px',
              left: 200 + 'px',
                'box-shadow': showBoundaries == true ? '#ffffff 0px 0px 0px 2px' : 'rgb(255 255 255 / 0%) 0px 0px 0px 2px',
                  'outline': showBoundaries == true ? 'dashed 2px black' : 'dashed 2px transparent',
              position: 'absolute',
              display: 'block'}">
              <!-- height: product.box.heightInches * dpi + 'px',
              width: product.box.widthInches * dpi + 'px',
              top:
              product.box.topLeftDmm.y * (dpi / 254.0) +
                'px',
              left:
              product.box.topLeftDmm.x * (dpi / 254.0) +
                'px', -->
                <!-- {{ product.box.topLeftDmm }} -->
                <!-- <div>{{ artObjectToShow }}</div> 
                
                
                
                transform: translate(${artObjectToShow.dragTransform.x}px, ${artObjectToShow.dragTransform.y}px) scale:(${artObjectToShow.dragTransform.scale.scaleX}, ${artObjectToShow.dragTransform.scale.scaleY}) rotate:(${artObjectToShow.dragTransform.rotate}deg);
              -->
            <div
                id="target"
                ref="targetRef"
                :style="`transform: translate(${artObjectToShow.dragTransform.x}px, ${artObjectToShow.dragTransform.y}px) scale(${artObjectToShow.dragTransform.scale.scaleX}, ${artObjectToShow.dragTransform.scale.scaleY}) rotate(${artObjectToShow.dragTransform.rotate}deg);
                      height: ${(this.store.allArts.value[artObjectToShow.artID].sizes[
                          artObjectToShow.artSizeID
                        ].dstfile.pixelHeight *
                          this.dpi) /
                        254.0}px;
                      width: ${(this.store.allArts.value[artObjectToShow.artID].sizes[
                          artObjectToShow.artSizeID
                        ].dstfile.pixelWidth *
                          this.dpi) /
                        254.0}px;
                        `"
                >
                <!-- max-width: ${maxWidth}; max-height: ${maxHeight}; min-width: ${minWidth}; min-height: ${minHeight}; -->
                <DSTPreview
                      :style="{
                        'left':
                          ((artObjectToShow.location.x -
                            artObjectToShow.dragLocation.x) *
                            dpi) /
                            254.0 +
                          'px',
                        'top':
                          ((artObjectToShow.location.y -
                            artObjectToShow.dragLocation.y) *
                            dpi) /
                            254.0 +
                          'px',
                      }"
                      :dwidth="
                        (this.store.allArts.value[artObjectToShow.artID].sizes[
                          artObjectToShow.artSizeID
                        ].dstfile.pixelWidth *
                          this.dpi) /
                        254.0
                      "
                      :dheight="
                        (this.store.allArts.value[artObjectToShow.artID].sizes[
                          artObjectToShow.artSizeID
                        ].dstfile.pixelHeight *
                          this.dpi) /
                        254.0
                      "
                      :dstFile="this.store.allArts.value[artObjectToShow.artID].sizes[
                          artObjectToShow.artSizeID
                        ].dstfile"
                      :layersColors="artObjectToShow.colors"
                      left="0"
                      top="0"
                      :arc="parseFloat(artObjectToShow.artArc)"
                    >
                    </DSTPreview>
            </div>
            <Moveable
                ref="moveableRef"
                :target="'#target'"
                :draggable="true"
                :scalable="true"
                :rotatable="true"
                :keepRatio="true"
                :bounds="bounds"
                :snappable="true"
                
                @drag="onDrag"
                @scale="onScale"
                @rotate="onRotate"
                
                />
                <!--
                :edgeDraggable="true"
                @render="onRender"
                @bound="onBound"
                
                :throttleDrag="throttleDrag"
                :startDragRotate="startDragRotate"
                :throttleRotate="throttleRotate"
                :throttleDragRotate="throttleDragRotate"
                :throttleScale="throttleScale"



                
                @render="onRender"
                @scaleStart="onScaleStart"

                :target="targetRef"
                :scalable="true"
                :rotatable="rotatable"
                :keepRatio="keepRatio"
                :renderDirections="renderDirections"
                :rotationPosition="rotationPosition"
                :draggable="draggable"
                :throttleDrag="throttleDrag"
                :edgeDraggable="edgeDraggable"
                :startDragRotate="startDragRotate"
                :throttleDragRotate="throttleDragRotate"
                @drag="onDrag"

                :bounds="bounds"
                @scale="onScale"
                @bound="onBound"
                
                @scaleStart="onScaleStart"
                    :resizable="resizable"
                    :throttleResize="throttleResize"
                    @resize="onResize" -->
        </div>
    </div>
</template>

<script>
import { designerStore } from "@/stores/designerStore";
import Moveable from "vue3-moveable";
import DSTPreview from './DSTPreview.vue';
import { ref } from "vue";

export default {
    components: {
         Moveable,
         DSTPreview 
        },
    setup() {
        const store = designerStore();

        // const rotatable = true;
        // const throttleRotate = 1;
        const rotationPosition = "top";
        const targetRef = ref(null);

        // const draggable = true;
        // const throttleDrag = 1;
        // const edgeDraggable = true;
        // const startDragRotate = 40;
        // const throttleDragRotate = 0;
        // const throttleScale = 0;
        // const snappable  = true;

        // const maxWidth = "auto";
        // const maxHeight = "auto";
        // const minWidth = "auto";
        // const minHeight = "auto";
        // const resizable = true;
        // const keepRatio = false;
        // const throttleResize = 1;
        // const renderDirections = ["nw","n","ne","w","e","sw","s","se"];
        
        const bounds = {"left":0,"top":0,"right":0,"bottom":0,"position":"css"};

      return {
            store,
            targetRef,
            // rotatable,
            // throttleRotate,
            rotationPosition,
            // maxWidth,
            // maxHeight,
            // minWidth,
            // minHeight,
            // resizable,
            // keepRatio,
            // throttleResize,
            // renderDirections,
            // draggable,
            // throttleDrag,
            // edgeDraggable,
            // startDragRotate,
            // throttleDragRotate,
            bounds,
            // throttleScale,
            // snappable 
        };
    },
    data() {
        return {
            arc: 0,
            trans: "",
            translateX: 0,
            translateY: 0,
            artObjectToShow: null,
            dpi: 24,
            product: null,
            productId: null,
            variantId: null,
            imageToPreview: null,

            x: 0,
            y: 0,
            scaleMatch: 0,
            scaleX: 0,
            scaleY: 0,
            rotateMatch: 0,
            rotate: 0,
            width: 0,
            height: 0,
            topX: 0,
            topY: 0,
            show:false
        }
    },
    async beforeMount() {
        await this.store.checkUserDesignsStore();
        await this.store.syncShopifyProduct(); //מפעיל את סנכרון הסטור עם החנות

        // this.artObjectToShow = 
        // {
        //     "imageName": "Black_Duffle_on_Wheels",
        //     "artID": 12,
        //     "artSizeID": 13,
        //     "artArc": 0,
        //     "colors": [
        //         32
        //     ],

        //     'dragTransform': {
        //     // 'transformString': transformString,
        //     'x': 183,
        //     'y': 149,
        //     'width': 334,
        //     'height': 256,
        //     'scale': {
        //       'scaleX': 1.5,
        //       'scaleY': 1.5
        //     },
        //     'rotate': 18,
        //     'topX': 0,
        //     'topY': 0,
        //   },


        //     "dragLocation": {
        //       "x": 0,
        //       "y": 0
        //         // "x": 455.22171616250716,
        //         // "y": 130.06334747500208
        //     },
        //     "location": {
        //       "x": 0,
        //       "y": 0
        //         // "x": 455.22171616250716,
        //         // "y": 130.06334747500208
        //     },
        //     "dragSize": {
        //         "w": 334,
        //         "h": 256
        //     }
        // };
        this.artObjectToShow=this.store.testArt;
        this.productId = "8838828589352";
        this.variantId = "47403201626408";
        this.imageToPreview = Object.values(this.store.allProducts[this.productId].variants[this.variantId]
        .images)[0].imageName;
        this.product = this.store.allProducts[this.productId].variants[this.variantId]
        .images[this.imageToPreview]
        //this.store.allArts.value[12];
        this.show=true;
    },
    // async mounted() {
        
    // },
    methods: {
        onRotate(e) {
            // this.arc = e.absoluteRotate; //e.drag.transform;
            // this.trans = e.drag.transform;
            // e.target.style.transform = e.drag.transform;
            // this.artObjectToShow.artArc = e.drag.transform;
            // document.getElementById("target-container").style.transform = e.drag.transform;
            this.changeStyleByTransform(e.drag.transform);
        },
        onResize(e) {
          //מבצע את השינוי בגודל רק אם הגודל החדש גדול מהגודל המינימלי וקטן מהמקסימלי
          if(parseInt(e.width) >= this.getMinWidthArtSize(this.artObjectToShow.artID) && e.width <= this.getMaxWidthArtSize(this.artObjectToShow.artID)) {
            e.target.style.width = `${e.width}px`;
            e.target.style.height = `${e.height}px`;
            e.target.style.transform = e.drag.transform;
            // document.getElementById("target-container").style.transform = e.drag.transform;
            this.changeStyleByTransform(e.drag.transform);
            this.trans = e.drag.transform;
          }
            // this.translateX = e.drag.translate[0];
            // this.translateY = e.drag.translate[1];
        },
        onDrag(e) {
            // e.target.style.transform = e.transform;
            // document.getElementById("target-container").style.transform = e.drag.transform;
            this.changeStyleByTransform(e.transform);
            this.trans = e.transform;
            // this.translateX = e.translate[0];
            // this.translateY = e.translate[1];
        },
        extractFloatNumber(originalString) { //"31.5591px" -> 31.5591
          const match = originalString.match(/[\d.]+/);
          return match ? parseFloat(match[0]) : 0;
        },
        onScale(e) {
           // Extract the scale values
           var scaleMatch = e.drag.transform.match(/scale\(([^,]+), ([^)]+)\)/);
          var scaleX = scaleMatch ? parseFloat(scaleMatch[1]) : 1;
          // var scaleY = scaleMatch ? parseFloat(scaleMatch[2]) : 1;

          // var height = e.target.style.width * scaleX;
          var width = this.extractFloatNumber(e.target.style.width) * scaleX;

          //מבצע את השינוי בגודל רק אם הגודל החדש גדול מהגודל המינימלי וקטן מהמקסימלי
          if(width >= this.getMinWidthArtSize(this.artObjectToShow.artID) && width <= this.getMaxWidthArtSize(this.artObjectToShow.artID)) {
            // e.target.style.transform = e.drag.transform;
            // document.getElementById("target-container").style.transform = e.drag.transform;
            this.changeStyleByTransform(e.drag.transform);
          }
        },

        getMinWidthArtSize(artId) {
          var sizesList = Object.values(this.store.getAllArtSizes(artId)).map(m => m.dstfile.pixelWidth);
          return (Math.min(...sizesList) * this.dpi) / 254;
        },
        getMaxWidthArtSize(artId) {
          var sizesList = Object.values(this.store.getAllArtSizes(artId)).map(m => m.dstfile.pixelWidth);
          return (Math.max(...sizesList) * this.dpi) / 254;
        },
        changeStyleByTransform(transformString) {
          // var transformString = 'translate(157px, 122.99999999999999px) scale(3.3038, 3.3038) rotate(-17.03187944027306deg)';

          // Extract the translate values (x and y)
          var translateMatch = transformString.match(/translate\(([^,]+), ([^)]+)\)/);
          var x = translateMatch ? parseFloat(translateMatch[1]) : 0;
          var y = translateMatch ? parseFloat(translateMatch[2]) : 0;

          // Extract the scale values
          var scaleMatch = transformString.match(/scale\(([^,]+), ([^)]+)\)/);
          var scaleX = scaleMatch ? parseFloat(scaleMatch[1]) : 1;
          var scaleY = scaleMatch ? parseFloat(scaleMatch[2]) : 1;

          // Extract the rotate value
          var rotateMatch = transformString.match(/rotate\(([^)]+)deg\)/);
          var rotate = rotateMatch ? parseFloat(rotateMatch[1]) : 0;

          // // Assuming width and height should be equal to scaleX and scaleY respectively for this context
          // var width = scaleX;
          // var height = scaleY;
          
          // Assuming width and height should be equal to scaleX and scaleY respectively for this context
          var width = (this.store.allArts.value[this.artObjectToShow.artID].sizes[
                          this.artObjectToShow.artSizeID
                        ].dstfile.pixelWidth *
                          this.dpi) /
                        254.0;
          var height = (this.store.allArts.value[this.artObjectToShow.artID].sizes[
                          this.artObjectToShow.artSizeID
                        ].dstfile.pixelHeight *
                          this.dpi) /
                        254.0;

          

          var topX = ((x * scaleX) - width) < 0 ? 0 : ((x * scaleX) - width);
          var topY = ((y * scaleY) - height) < 0 ? 0 : ((y * scaleY) - height);

          // this.artObjectToShow.artArc = rotate;

          var result = {
        // 'transformString': transformString,
        'x': x,
        'y': y,
        'width': width,
        'height': height,
        'scale': {
          'scaleX': scaleX,
          'scaleY': scaleY
        },
        'rotate': rotate,
        'topX': topX,
        'topY': topY,
      };

      this.artObjectToShow.dragTransform = result;

          console.log('transform = ', transformString);
          console.log('x:', x);
          console.log('y:', y);
          console.log('width:', width);
          console.log('height:', height);
          console.log('scale:', scaleX);
          console.log('rotate:', rotate);
          console.log('topX:', topX);
          console.log('topY:', topY);
        },
        // onScaleStart(e) {
        //     e.datas.minScaleSize = [100,100];
        //     // e.set([100, 100]);
        //     // e.setMinScaleSize([100, 100]);
        //     // e.setMaxScaleSize([500, 500]);
        // },
        // onRender(e) {
        //     e.target.style.cssText += e.cssText;
        // },
        // onBound(e) {
        //     console.log(e);
        // },
    }
};
</script>